import { Button, Dropdown, Icon, InputText } from "@uigovpe/components";
import type { ProductStatusFilter } from "../types";

const statusOptions = [
  { label: "Todos status", value: "all" },
  { label: "Publicado", value: "published" },
  { label: "Rascunho", value: "draft" },
  { label: "Oculto", value: "hidden" },
];

type Props = {
  categories: { label: string; value: string }[];
  category: string;
  search: string;
  status: ProductStatusFilter;
  onCategoryChange: (value: string) => void;
  onNewProduct: () => void;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: ProductStatusFilter) => void;
};

export default function ProductFilters(props: Props) {
  return (
    <div className="grid! grid-cols-1! gap-6! lg:grid-cols-[minmax(220px,1.5fr)_minmax(160px,1fr)_minmax(180px,1fr)_minmax(164px,auto)]! lg:items-end! lg:gap-14!">
      <div className="relative!">
        <InputText
          label="Busque por produto"
          placeholder="Digite nome do produto"
          value={props.search}
          className="h-10! w-full! pr-10!"
          onChange={(event) => props.onSearchChange(event.target.value)}
        />
        <Icon
          icon="search"
          className="absolute! right-3! bottom-2.5! text-[20px]! text-[#4e3873]!"
        />
      </div>
      <Dropdown
        label="Categorias"
        value={props.category}
        options={[
          { label: "Todas categorias", value: "all" },
          ...props.categories,
        ]}
        className="h-10! w-full!"
        onChange={(event) => props.onCategoryChange(String(event.value))}
      />
      <Dropdown
        label="Status"
        value={props.status}
        options={statusOptions}
        className="h-10! w-full!"
        onChange={(event) =>
          props.onStatusChange(event.value as ProductStatusFilter)
        }
      />
      <Button
        type="button"
        label="Novo Produto"
        className="min-h-12! min-w-[186px]! text-white!"
        icon={<Icon icon="add" className="text-[22px]! text-white!" />}
        onClick={props.onNewProduct}
      />
    </div>
  );
}
